import React from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import useStyle from "./Styles";

interface Props {
  plan: string;
  setPlan: (a: string) => void;
  setting?: boolean;
}

const SlidingButton: React.FC<Props> = ({ plan, setPlan }) => {
  const { classes } = useStyle();
  const tabValue = plan === "annual" ? 1 : 0;

  const handleChange = (_: React.SyntheticEvent, selectedTabValue: number) => {
    const selectedPlan = selectedTabValue === 0 ? "monthly" : "annual";
    setPlan(selectedPlan);
  };

  return (
    <Box className={classes.box}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        classes={{
          root: classes.root,
          flexContainer: classes.flexContainer,
          indicator: classes.indicator,
        }}
      >
        <Tab
          disableTouchRipple
          className={`${classes.tab} ${
            plan === "monthly" ? classes.selectedTab : classes.unselectedTab
          }`}
          label="Monthly Plans"
        />
        <Tab
          disableTouchRipple
          className={`${classes.tab} ${
            plan === "annual" ? classes.selectedTab : classes.unselectedTab
          }`}
          label={
            <Typography className={classes.annualLabel}>
              Annual (Save up to 17%)
            </Typography>
          }
        />
      </Tabs>
    </Box>
  );
};

export default SlidingButton;
